import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Carousel from 'react-slick';
// core components
import parallaxStyle from 'assets/jss/material-kit-react/components/parallaxStyle.jsx';
import ContentLoader from 'react-content-loader';
import ProgressiveImage from 'react-progressive-image';
import default1 from '../../assets/img/default1.jpg';
import default2 from '../../assets/img/default2.jpg';
import default3 from '../../assets/img/default3.jpg';

const defaultImages = [
    {
        large: default1
    },
    {
        large: default2
    },
    {
        large: default3
    }
];
var isMounted = true;
class CaroselParallax extends React.Component {
    constructor(props) {
        super(props);
    }

    resetTransform() {
        var windowScrollTop = window.pageYOffset / 3;
        this.setState({
            transform: 'translate3d(0,' + windowScrollTop + 'px,0)'
        });
    }

    renderLoading = index => {
        return (
            <div style={{ width: 800, height: 520 }} key={index}>
                <ContentLoader
                    width={800}
                    height={520}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="800" height="520" />
                </ContentLoader>
            </div>
        );
    };
    render() {
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 760,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };
        const { children, images } = this.props;

        return (
            <div>
                <Carousel autoPlay {...settings}>
                    {/* {images.length >= 1
                        ? */}
                    {images.map((image, index) => {
                        return (
                            <div ref="parallax" key={index}>
                                <ProgressiveImage
                                    delay={2000}
                                    src={image.large}
                                    placeholder="carousel-image"
                                >
                                    {(src, loading) =>
                                        loading ? (
                                            this.renderLoading()
                                        ) : (
                                            <img
                                                width={'100%'}
                                                height={'400px'}
                                                aria-label="provider-img"
                                                src={src}
                                            />
                                        )
                                    }
                                </ProgressiveImage>
                            </div>
                        );
                    })

                    // : defaultImages.map((image, index) => {
                    //       return (
                    //           <div ref="parallax" key={index}>
                    //               <ProgressiveImage
                    //                   delay={2000}
                    //                   src={image.large}
                    //                   placeholder="carousel-image"
                    //               >
                    //                   {(src, loading) =>
                    //                       loading ? (
                    //                           this.renderLoading()
                    //                       ) : (
                    //                           <img
                    //                               width={'100%'}
                    //                               height={'400px'}
                    //                               aria-label="provider-img"
                    //                               src={src}
                    //                           />
                    //                       )
                    //                   }
                    //               </ProgressiveImage>
                    //           </div>
                    //       );
                    //   })}
                    }
                </Carousel>

                {children}
            </div>
        );
    }
}

CaroselParallax.propTypes = {
    className: PropTypes.string,
    filter: PropTypes.bool,
    children: PropTypes.node,
    style: PropTypes.string,
    image: PropTypes.string
};

export default withStyles(parallaxStyle)(CaroselParallax);



// WEBPACK FOOTER //
// ./src/components/Parallax/CaroselParallax.jsx